import React from 'react';
import { Link } from 'react-router-dom';

const CateringServicePage = () => {
  return (
    <div
      className="bg-cover bg-center h-screen flex flex-col items-center justify-center"
      style={{ backgroundImage: `url('/untitled-1173.0.jpeg')` }}
    >
      <div className="bg-amber-400 bg-opacity-60 text-white py-16 px-4 text-center">
        <h1 className="text-4xl text-orange-800 font-bold mb-4">Catering Services</h1>
        <p className="text-lg text-black font-bold mb-4">
          Let's cater your next event with special Ethiopian food.
        </p>
        <p className="text-lg text-black font-bold mb-8">
          We provide catering services for:
        </p>
        <ul className="text-lg text-black font-bold text-opacity-80 mb-8">
          <li>Birthday Parties</li>
          <li>Weddings</li>
          <li>Corporate Events</li>
          <li>Anniversaries</li>
          <li>Family Gatherings</li>
          {/* Add more occasions as needed */}
        </ul>
        <p className="text-lg text-black font-bold mb-4">
          We will deliver complimentary coffe ceremony for free.
        </p>
        <Link to="/menu" >
        <button
          className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-6 rounded-full transition duration-300"
        >
          Explore Catering Menu
        </button>
        </Link>
        <Link to='/contact'>
        <button
          className="bg-blue-500 m-4 hover:bg-blue-600 text-white font-semibold py-2 px-6 rounded-full transition duration-300"
        >
          Contact Us for pricing
        </button>
        </Link>
      </div>
    </div>
  );
};

export default CateringServicePage;
